<script setup lang="ts">
import { computed, onErrorCaptured } from 'vue';
import { useModal } from '@/shared/composables/useModal.js';

const { overlays, unmount, close } = useModal();

const mountedOverlays = computed(() => overlays.filter((overlay) => overlay.isMounted));

const onAfterLeave = (id) => {
    close(id);
    unmount(id);
};

const onClose = (id, value) => {
    close(id, value);
};

// Error boundary for modal components
onErrorCaptured((error, component, errorInfo) => {
    console.error('Modal component error:', error, errorInfo);
    // Continue rendering other modals
    return false;
});
</script>

<template>
    <component
        :is="overlay.component"
        v-for="overlay in mountedOverlays"
        :key="overlay.id"
        v-model:open="overlay.isOpen"
        v-memo="[overlay.id, overlay.isOpen, overlay.props]"
        v-bind="overlay.props"
        @close="(value) => onClose(overlay.id, value)"
        @after:leave="onAfterLeave(overlay.id)"
    />
</template>
